export default __webpack_public_path__ + "static/media/021-signpost.0ad51ecb.svg";